/**
 * The screening-answer pairs a candidate's submit sends.
 *
 * One definition, both candidate pages: the career-site apply flow and the
 * review-details flow for sourced and bulk-uploaded candidates built this
 * array separately and identically, and both dropped the same pair.
 *
 * **Every question that was on screen gets a pair, blank included.** The
 * server distinguishes an omitted pair from an empty one on purpose
 * (`application_questions/service.py::validate_answers`): omitted means "left
 * alone", empty means "cleared", and a cleared optional answer is removed from
 * the application and from the recruiter's Additional Q&A. Filtering the
 * blanks out here turned every clear into an omission, so the candidate wiped
 * a box, submitted, saw the success toast, and the old answer stood.
 *
 * A question the candidate never touched sends an empty pair too, which is the
 * same instruction — there is nothing to leave alone — and the server stores
 * it as no answer, which is what an unanswered optional question is. Required
 * questions never reach here blank: both pages gate the submit on them, and
 * the server refuses one anyway.
 */
export const buildQuestionAnswers = (screeningQuestions, answers = {}) =>
  (screeningQuestions || []).map((question) => ({
    job_question_id: question.id,
    answer_value: answers?.[question.id] ?? "",
  }));

export default buildQuestionAnswers;
